<template>
  <modal name="resize-modal" :height="420" :clickToClose="false" @before-open="beforeOpen">
    <div class="kt-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">Websize Dimension</h3>
        </div>
      </div>
      <div class="kt-portlet__body h-84 overflow-y-auto">
        <div class="row" v-for="(resize, index) in websizes" :key="index">
          <div class="col-lg-5 mb-4">
            <label>Width</label>
            <input type="number" class="form-control" v-model="resize.width" />
          </div>
          <div class="col-lg-5 mb-4">
            <label>Height</label>
            <input type="number" class="form-control" v-model="resize.height" />
          </div>
          <div class="col-lg-2 mb-4">
            <div style="padding-top: 2.25rem;">
              <button class="btn btn-sm btn-danger" @click.prevent="deleteRow(index)">X</button>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <div class="kt-form__actions kt-form__actions--right">
          <div class="row">
            <div class="col kt-align-left">
              <button type="button" class="btn btn-success" @click.prevent="addRow">Add More</button>
            </div>
            <div class="col kt-align-right">
              <button type="button" class="btn btn-secondary" @click.prevent="close">Close</button>
              <button type="button" class="btn btn-brand ml-2" @click.prevent="save">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ResizeModal',
  data() {
    return {
      websizes: [],
    };
  },
  computed: {
    ...mapGetters({
      orderWebsizes: 'order/websizes',
    }),
  },
  methods: {
    addRow() {
      this.websizes.push({
        text: 'Size ' + (this.websizes.length + 1),
        width: '',
        height: '',
      });
    },
    deleteRow(index) {
      this.websizes.splice(index, 1);
    },
    save() {
      let emptyValueExist = false;

      this.websizes.map((resize) => {
        if (resize.width === '' || resize.height === '') {
          emptyValueExist = true;
        }
      });

      if (emptyValueExist) {
        return;
      } else {
        this.$emit('websizes', this.websizes);
      }

      this.$modal.hide('resize-modal');
    },
    close() {
      this.websizes = this.orderWebsizes;

      this.$emit('close');

      this.$modal.hide('resize-modal');
    },
    beforeOpen() {
      this.websizes = this.orderWebsizes;
    },
  },
};
</script>

<style>
.mb-4 {
  margin-bottom: 1rem !important;
}
.h-84 {
  height: 21rem !important;
}
.overflow-y-auto {
  overflow-y: auto;
}
</style>
